import React, { useState, lazy } from 'react';
export function Reason4() {
  const [activeTestimonial, setActiveTestimonial] = useState(0);
  const testimonials = [{
    quote: "I bought one for home and one for my office. First time in 15 years I've gone 30 days without calling in sick.",
    author: 'Sarah from Phoenix'
  }, {
    quote: 'Sweet relief! I received this product on a day when I was having a massive migraine. Not only did it provide relief, but it relaxed me to the point I could fall asleep.',
    author: 'Marcus, software developer'
  }, {
    quote: 'The person who invented this deserves a Nobel Prize... 100% worth the money.',
    author: 'Jennifer, mother of three'
  }];
  const mosaicTestimonials = [{
    image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?q=80&w=150&h=150&auto=format&fit=crop',
    quote: 'Life-changing after 20 years of pain.',
    name: 'Rebecca, 42'
  }, {
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?q=80&w=150&h=150&auto=format&fit=crop',
    quote: 'Finally slept through the night again.',
    name: 'Michael, 37'
  }, {
    image: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?q=80&w=150&h=150&auto=format&fit=crop',
    quote: 'Canceled my neurologist appointment permanently.',
    name: 'Tanya, 29'
  }, {
    image: 'https://images.unsplash.com/photo-1539571696357-5a69c17a67c6?q=80&w=150&h=150&auto=format&fit=crop',
    quote: 'No more emergency room visits.',
    name: 'James, 34'
  }, {
    image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?q=80&w=150&h=150&auto=format&fit=crop',
    quote: 'Threw away all my medication.',
    name: 'Emma, 45'
  }, {
    image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?q=80&w=150&h=150&auto=format&fit=crop',
    quote: 'First vacation in years without pain.',
    name: 'David, 51'
  }, {
    image: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?q=80&w=150&h=150&auto=format&fit=crop',
    quote: 'My kids have their mom back.',
    name: 'Sarah, 38'
  }, {
    image: 'https://images.unsplash.com/photo-1552058544-f2b08422138a?q=80&w=150&h=150&auto=format&fit=crop',
    quote: 'Worth every single penny.',
    name: 'Robert, 43'
  }];
  const stats = [{
    percentage: 73,
    description: 'report better sleep (even when not in pain)'
  }, {
    percentage: 61,
    description: 'say their light sensitivity decreased permanently'
  }, {
    percentage: 44,
    description: 'stopped needing their "emergency" medications'
  }, {
    percentage: 89,
    description: 'use it daily as prevention, not just treatment'
  }];
  return <div className="py-12 border-t border-[#F1F5F9]" data-id="element-404">
      <div className="flex flex-col md:flex-row md:gap-8" data-id="element-405">
        <div className="md:w-2/3" data-id="element-406">
          <div className="flex items-center mb-4" data-id="element-407">
            <div className="bg-[#0EA5B7] text-white font-bold rounded-full w-10 h-10 flex items-center justify-center mr-4" data-id="element-408">
              4
            </div>
            <h2 className="text-2xl font-bold text-[#0F172A]" data-id="element-409">Reason #4:</h2>
          </div>
          <h3 className="text-xl font-semibold text-[#0F172A] mb-6" data-id="element-410">
            The "Impossible" Recovery Stories That Keep Neurologists Up At Night
          </h3>
          <div className="prose prose-slate max-w-none" data-id="element-411">
            <p data-id="element-412">"I forgot I had a migraine."</p>
            <p data-id="element-413">
              That's not a typo. That's a direct quote from Maria, a 47-year-old
              teacher who'd suffered for 23 years.
            </p>
            <p data-id="element-414">
              When 4,782 people report the same "impossible" experience, you
              have to pay attention.
            </p>
            <p data-id="element-415">Here's what they're describing:</p>
            <div className="my-8" data-id="element-416">
              <div className="bg-white p-6 rounded-lg shadow-sm border-l-4 border-[#0EA5B7]" data-id="element-417">
                <p className="italic mb-2" data-id="element-418">
                  {testimonials[activeTestimonial].quote}
                </p>
                <p className="text-sm font-medium text-[#0EA5B7]" data-id="element-419">
                  {testimonials[activeTestimonial].author}
                </p>
              </div>
              <div className="flex justify-center mt-4 space-x-2" data-id="element-420">
                {testimonials.map((_, index) => <button key={index} onClick={() => setActiveTestimonial(index)} className={`w-3 h-3 rounded-full ${activeTestimonial === index ? 'bg-[#0EA5B7]' : 'bg-[#F1F5F9]'}`} aria-label={`View testimonial ${index + 1}`} data-id="element-421" />)}
              </div>
            </div>
            {/* Premium Testimonial Mosaic */}
            <div className="my-10" data-id="element-422">
              <div className="grid grid-cols-2 md:grid-cols-4 gap-6" data-id="element-423">
                {mosaicTestimonials.map((item, index) => <div key={index} className="flex flex-col items-center text-center" data-id="element-424">
                    <div className="w-20 h-20 md:w-24 md:h-24 mb-3 overflow-hidden rounded-full shadow-md" data-id="element-425">
                      <picture data-id="element-426">
                        <source srcSet={item.image} type={item.image.includes('webp') ? 'image/webp' : 'image/jpeg'} data-id="element-427" />
                        <img src={item.image} alt={`${item.name} testimonial`} className="w-full h-full object-cover" width="150" height="150" loading="lazy" data-id="element-428" />
                      </picture>
                    </div>
                    <p className="text-sm font-medium mb-1 text-[#0F172A]" data-id="element-429">
                      "{item.quote}"
                    </p>
                    <p className="text-xs text-[#64748B]" data-id="element-430">{item.name}</p>
                  </div>)}
              </div>
              <p className="text-center text-sm text-[#334155] italic mt-6" data-id="element-431">
                From teachers to software developers to moms of three — over
                4,700 people describe the same impossible relief.
              </p>
            </div>
            <p data-id="element-432">
              But here's the part that makes skeptics scratch their heads...
            </p>
            <p data-id="element-433">
              These aren't gradual improvements. People describe an almost
              instantaneous shift. As if someone flipped a switch.
            </p>
            <p data-id="element-434">
              Dr. Jennifer Tsai, an optometrist studying the phenomenon,
              believes it's the multi-modal approach:{' '}
              <em data-id="element-435">
                "When you simultaneously address muscle tension, blood flow,
                nerve pressure, and stress response, you create what we call a
                'cascade interruption.' The body's pain system essentially
                resets."
              </em>
            </p>
            <p data-id="element-436">The reports get stranger:</p>
            <ul className="list-disc pl-6 space-y-2 my-4" data-id="element-437">
              <li data-id="element-438">73% report better sleep (even when not in pain)</li>
              <li data-id="element-439">61% say their light sensitivity decreased permanently</li>
              <li data-id="element-440">74% stopped needing their "emergency" medications</li>
              <li data-id="element-441">89% use it daily as prevention, not just treatment</li>
            </ul>
            <p data-id="element-442">
              One Reddit user was brutally honest:{' '}
              <em data-id="element-443">
                "I was skeptical but desperate. I barely have the strength to
                put it on when I have a migraines and I puke, but I greatfull
                because of the relief it gives me."
              </em>
            </p>
            <p data-id="element-444">Think about that.</p>
            <p data-id="element-445">
              When something helps people through their absolute worst moments —
              when they can barely function — that's not placebo. That's
              profound.
            </p>
          </div>
        </div>
        <div className="md:w-1/3 mt-8 md:mt-0" data-id="element-446">
          <div className="bg-white rounded-lg shadow-sm border border-[#F1F5F9] p-4" data-id="element-447">
            <h4 className="font-medium text-[#0F172A] mb-4" data-id="element-448">
              User-Reported Benefits
            </h4>
            <div className="grid grid-cols-2 gap-4" data-id="element-449">
              {stats.map((stat, index) => <div key={index} className="bg-[#F1F5F9] p-3 rounded-lg text-center" data-id="element-450">
                  <div className="text-2xl font-bold text-[#0EA5B7]" data-id="element-451">
                    {stat.percentage}%
                  </div>
                  <div className="text-xs text-[#334155] mt-1" data-id="element-452">
                    {stat.description}
                  </div>
                </div>)}
            </div>
            <div className="mt-6 p-4 bg-[#F1F5F9] rounded-lg border-l-4 border-[#0EA5B7]" data-id="element-453">
              <p className="text-sm italic" data-id="element-454">
                "I've tried everything from Botox to acupuncture. Nothing worked
                like this device. After 15 minutes, I felt like someone had
                lifted a 50-pound weight off my head."
              </p>
              <p className="text-xs text-[#334155] mt-2" data-id="element-455">
                — Verified Purchaser
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>;
}